<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Ad</label>
            <input class="form-control" placeholder="Ad" v-model="value.Name"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Maksimum İşe Giriş Günü</label>
            <feather-icon class="text-warning ml-50 mb-20" icon="InfoIcon" v-b-tooltip.noninteractive.hover.bottom="'Atama yapacağınız ayın X gününden sonra işe girmiş personel, bu kuralı seçerek atayacağınız KYKM kaydında hak etmemiş sayılacaktır.'"></feather-icon> 
            <v-select :options="days" v-model="value.StartDayMustBefore" placeholder="Maksimum İşe Giriş Günü"></v-select>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Minimum Çalışma Günü</label>
            <feather-icon class="text-warning ml-50 mb-20" icon="InfoIcon" v-b-tooltip.noninteractive.hover.bottom="'Atama yapacağınız ay içerisinde, personelin günlük bazda kazanç hak ettiği günlerin(N, HT, GT, I) toplam sayısı X günden az olursa, personel bu kuralı seçerek atayacağınız KYKM kaydında hak etmemiş sayılacaktır.'"></feather-icon> 
            <v-select :options="days" v-model="value.WorkedMinimumInMonth" placeholder="Minimum Çalışma Günü"></v-select>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Üst Limit Tipi</label>
            <feather-icon class="text-warning ml-50 mb-20" icon="InfoIcon" v-b-tooltip.noninteractive.hover.bottom="'Atama yapmak için girdiğiniz tutar ne kadar büyük olursa olsun, atama hakedişinde hesaplanan tutar aşağıda seçeceğiniz üst limiti geçmeyecektir.'"></feather-icon> 
            <v-select-list v-model="limitType" label="Value" placeholder="Limit Tipi" :options="limitTypes"/>
        </div>
        <div class="col-12 mb-1" v-if="value.LimitType == '0'">
            <label class="form-label">Üst Limit Değeri</label>
            <v-currency-input input-class="text-right w-100" :value="value.LimitValue" v-on:update-value="currencyAmount => value.LimitValue = currencyAmount"></v-currency-input>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">KYKM Türü</label>
            <feather-icon class="text-warning ml-50 mb-20" icon="InfoIcon" v-b-tooltip.noninteractive.hover.bottom="'Atama yapmak için girdiğiniz tutarı, personelin hak edip etmediğinin hesaplaması yapılırken hesaplamaya dahil edilecek kazanç ya da kesintilerdir.'"></feather-icon> 
            <v-select-list multiple v-model="type" :disabled="(types || []).length == 0" :options="types" label="COMBINE" placeholder="KYKM Türü">
                <template #option="{ COMBINE }">
                    {{COMBINE}}
                </template>
            </v-select-list>
        </div>
        <div class="col-12 mb-50" v-if="value.AllBranches == false">
            <label class="form-label">Garaj</label>
            <feather-icon class="text-warning ml-50 mb-20" icon="InfoIcon" v-b-tooltip.noninteractive.hover.bottom="'Bu kuralı seçerek yapacağınız atamalarda; yalnızca atama tarihinde aşağıda seçtiğiniz garajda bulunan personellere hakediş verilecektir.'"></feather-icon> 
            <v-select-list v-model="garage" multiple label="Combine" placeholder="Garaj" :options="garages"/>
        </div>
         <div class="col-12">
            <b-form-checkbox v-model="value.AllBranches">Tüm Şubeler</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations';
import VCurrencyInput from '@/components/VCurrencyInput.vue';
import NetsisApi from '@/api/hr-netsis';
import VehicleOperationsApi from '@/api/vehicle-operations';
import { BFormCheckbox } from 'bootstrap-vue';
import { VBTooltip } from 'bootstrap-vue'

export default {
    components:{
        VCurrencyInput,
        BFormCheckbox
    },
    props:{
        value:Object
    },
    directives:{
        'b-tooltip':VBTooltip
    },
    data(){
        return {
            days:Array.from({length: 31}, (_, i) => i + 1),
            limitTypes:[],
            types:[],
            groups:[
                {Name:'Kazanç',Id:1},
                {Name:'Yardım',Id:2},
                {Name:'Kesinti',Id:3},
                {Name:'Muafiyet',Id:4}
            ],
            garages:[]
        }
    },
    watch:{
        "value.AllBranches"(nw,ow){
            if(nw == true){
                this.value.GarageIds = []
            }
        }
    },
    mounted(){
        this.getLimitTypes()
        this.getKYKMs()
        this.getGarages()
    },
    methods:{
        getLimitTypes(){
            EmployeeOperationsApi.SalaryEffect.Assign.Rule.LimitTypeList().then(res=>{
                this.limitTypes = res.data.Data
            })
        },
        getKYKMs(){
            NetsisApi.KYKMList().then(res=>{
                this.types = res.data?.map(d => ({
                    ...d,
                    GROUP_NAME:this.groups.find(g => g.Id == d.TIP)?.Name || '',
                    COMBINE:[this.groups.find(g => g.Id == d.TIP)?.Name || '',d.AD].join(' - ')
                }))
            })
        },
        getGarages(){
            VehicleOperationsApi.Garage.List().then(res=>{
                this.garages = res.data.Data?.map(g => ({
                    ...g,
                    Combine:[g.BranchName,g.GarageName].join(' - ')
                }))
            })
        }  
    },
    computed:{
        limitType:{
            get:function(){
                return this.limitTypes.find(b=>b.Key==this.value.LimitType)
            },
            set:function(value){
                this.value.LimitType = value?.Key || null
            }
        },
        type:{
            get:function(){
                return this.types.filter(s=>this.value.KYKMS.includes([s.TIP,s.SIRA_NO].join('-')))
            },
            set:function(value){
                this.value.KYKMS = value?.map(v => [v.TIP,v.SIRA_NO].join('-')) || []
            }
        },
        garage:{
            get:function(){
                return this.garages.filter(s=>this.value.GarageIds.includes(s.Id))
            },
            set:function(value){
                this.value.GarageIds = value?.map(v => v.Id) || []
            }
        }
    }
}
</script>